// extracted by mini-css-extract-plugin
export default {"background":"description_background__SrW-a","wrapper":"description_wrapper__rCUof","text":"description_text__Y2UUp"};